import React, { useEffect, useState } from 'react';
import { View, StyleSheet, ScrollView, FlatList, ActivityIndicator, TouchableOpacity } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import Divider from '../../divider/Divider';
import HorizontalFilterComp from '../pendingApplicationScreen/HorizontalFilterComp';
import TextInput from '../../textInput/TextInput';
import { isCloseToBottom } from '../../stack/utils';
import { addCommasToNumber, showPlj, showRegisterCustomer, showShareLink } from '../utils';
import ShimmerTable from '../customerDetailsTable/ShimmerTable';
import EmptyScreen from '../pendingApplicationScreen/EmptyScreen';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
export var PendingCustomerDataProps;
(function (PendingCustomerDataProps) {
    PendingCustomerDataProps["fullName"] = "fullName";
    PendingCustomerDataProps["phoneNumber"] = "phoneNumber";
    PendingCustomerDataProps["phoneNo"] = "phoneNo";
    PendingCustomerDataProps["leadPhoneNumber"] = "leadPhoneNumber";
    PendingCustomerDataProps["status"] = "status";
    PendingCustomerDataProps["eligibleCreditAmount"] = "eligibleCreditAmount";
    PendingCustomerDataProps["eligibleCreditLimit"] = "eligibleCreditLimit";
    PendingCustomerDataProps["leadEligibleCreditAmount"] = "leadEligibleCreditAmount";
    PendingCustomerDataProps["updatedAt"] = "updatedAt";
    PendingCustomerDataProps["leadupdatedTime"] = "leadupdatedTime";
    PendingCustomerDataProps["leadId"] = "leadId";
    PendingCustomerDataProps["action"] = "action";
})(PendingCustomerDataProps || (PendingCustomerDataProps = {}));
const PendingApplicationMobileScreen = ({ height, activeIndex, currentSearchContext, PendingCustomerData, pendingCustomerCount, pendingCustomerAction, pendingRegisteredCustomerAction, registeredCustomerAction, shareLinkAction, registeredCustomerActionNrml, pendingRegisteredCustomerActionNrml, pendingCustomerActionNrml, trackPendingCustomerJourney, viewDetailsAction, shareLinkRef, pendingDataFetched = false, triggerAction, }) => {
    const scrollViewRef = React.useRef(null);
    const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [dataCount, setDataCount] = useState(pendingCustomerCount);
    const [currentActiveTabIndex, setCurrentActiveIndex] = useState(activeIndex || 1);
    const [currentPageNumber, setCurrentpageNumber] = useState(2);
    const [hasReachedBottom, setHasReachedBottom] = useState(false);
    const [isDataFetched, setDataFetched] = useState(pendingDataFetched);
    const [showRC, setShowRCustomer] = useState(showRegisterCustomer());
    const [showLink, setShowLink] = useState(showShareLink());
    const [showJourney, setShowJourney] = useState(showPlj());
    useEffect(() => {
        if (currentSearchContext)
            setSearchText(currentSearchContext);
    }, [currentSearchContext]);
    useEffect(() => {
        setDataFetched(pendingDataFetched);
    }, [pendingDataFetched]);
    useEffect(() => {
        if (PendingCustomerData?.data !== undefined)
            setData(prevData => prevData.concat(PendingCustomerData?.data));
    }, [PendingCustomerData?.data]);
    const onTabPress = async ({ activeIndex }) => {
        if (currentActiveTabIndex === activeIndex)
            return;
        setCurrentpageNumber(2);
        setCurrentActiveIndex(activeIndex);
        setData([]);
        if (activeIndex === 1) {
            await triggerAction({
                ...pendingCustomerActionNrml,
                payload: {
                    searchContext: searchText,
                    ...pendingCustomerActionNrml.payload,
                }
            });
        }
        if (activeIndex === 2) {
            await triggerAction({
                ...pendingRegisteredCustomerActionNrml,
                payload: {
                    searchContext: searchText,
                    pendingRegisteredCustomerActionNrml,
                }
            });
        }
        else if (activeIndex === 3) {
            await triggerAction({
                ...registeredCustomerActionNrml,
                payload: {
                    searchContext: searchText,
                    registeredCustomerActionNrml,
                }
            });
        }
    };
    const handleSearch = async (text) => {
        if (text?.includes('+') && text?.length < 4 && text?.length > 0)
            return;
        setData([]);
        setCurrentpageNumber(2);
        setDataFetched(false);
        if (currentActiveTabIndex === 1) {
            await triggerAction({
                ...pendingCustomerAction,
                payload: {
                    searchContext: text,
                    ...pendingCustomerAction.payload,
                }
            });
        }
        else if (currentActiveTabIndex === 2) {
            await triggerAction({
                ...pendingRegisteredCustomerAction,
                payload: {
                    searchContext: text,
                    ...pendingRegisteredCustomerAction.payload,
                }
            });
        }
        else if (currentActiveTabIndex === 3) {
            await triggerAction({
                ...registeredCustomerAction,
                payload: {
                    searchContext: text,
                    ...registeredCustomerAction.payload,
                }
            });
        }
    };
    const clearTextSearchAction = () => {
        setSearchText('');
        if (searchText?.length > 0)
            handleSearch('');
    };
    const getName = (customer, currentActiveTabIndex) => {
        let name = '';
        if (currentActiveTabIndex === 3) {
            name = customer?.fullName;
        }
        else if (currentActiveTabIndex === 2) {
            if (customer?.leadName) {
                name = customer?.leadName;
            }
            else
                name = customer?.phoneNo?.substr(3);
        }
        else {
            if (customer?.fullName) {
                name = customer?.fullName;
            }
            else if (customer?.leadPhoneNumber !== undefined && customer?.leadPhoneNumber !== null) {
                name = customer?.leadPhoneNumber?.substr(3);
            }
            else
                name = '';
        }
        return name;
    };
    const getCreditLimit = (customer, currentActiveTabIndex) => {
        let limit = 0;
        if (currentActiveTabIndex === 3) {
            limit = customer?.eligibleCreditAmount;
        }
        if (currentActiveTabIndex === 2) {
            limit = customer?.eligibleCreditLimit;
        }
        else {
            if (customer?.leadEligibleCreditAmount !== undefined && customer.leadEligibleCreditAmount !== null) {
                limit = customer?.leadEligibleCreditAmount;
            }
            else
                limit = customer?.eligibleCreditAmount;
        }
        return `₹${addCommasToNumber(limit)}`;
    };
    const renderCustomerCard = (customer) => {
        return (React.createElement(View, { style: { padding: 12, borderWidth: 1, borderColor: '#E4E7EC', borderRadius: 8, marginBottom: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: getName(customer, currentActiveTabIndex), color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 8, flexDirection: 'row', alignItems: 'baseline' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Status: ', color: ColorTokens.Grey_Night }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: `${customer?.status}`, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 8, flexDirection: 'row', alignItems: 'baseline' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Available credit limit: ', color: ColorTokens.Grey_Night }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: getCreditLimit(customer, currentActiveTabIndex), color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 12, marginHorizontal: -12 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, { style: { flexDirection: 'row', paddingTop: 8, paddingBottom: -4 } },
                React.createElement(TouchableOpacity, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, onPress: async () => {
                        await triggerAction({
                            ...viewDetailsAction,
                            payload: {
                                currentActiveTabIndex: currentActiveTabIndex,
                                searchContext: searchText,
                                customerData: customer,
                                customerType: (customer?.applicationId === null || customer?.applicationId === undefined) ? 'PENDING_REGISTRATION' : 'COMPLETED_REGISTRATION',
                                ...viewDetailsAction.payload,
                            }
                        });
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'View detail', color: ColorTokens.Primary_100 })),
                showLink && React.createElement(View, { style: { borderWidth: 1, borderColor: '#F3F5FC', marginTop: -8, marginBottom: -12 } }),
                showLink && !(customer?.applicationId === null || customer?.applicationId === undefined) && React.createElement(TouchableOpacity, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, onPress: async () => {
                        await triggerAction({
                            ...shareLinkAction,
                            payload: {
                                currentActiveTabIndex: currentActiveTabIndex,
                                searchContext: searchText,
                                customerData: customer,
                                ...shareLinkAction.payload,
                            }
                        });
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Share link', color: ColorTokens.Primary_100 })),
                showJourney && React.createElement(View, { style: { borderWidth: 1, borderColor: '#F3F5FC', marginTop: -8, marginBottom: -12 } }),
                showJourney &&
                    React.createElement(TouchableOpacity, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, onPress: async () => {
                            if (trackPendingCustomerJourney)
                                await triggerAction({
                                    ...trackPendingCustomerJourney,
                                    payload: {
                                        customerType: (customer?.applicationId === null || customer?.applicationId === undefined) ? 'PENDING_REGISTRATION' : 'COMPLETED_REGISTRATION',
                                        value: customer,
                                        currentActiveTabIndex,
                                        searchContext: searchText,
                                        ...trackPendingCustomerJourney.payload,
                                    }
                                });
                        } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: (customer?.applicationId === null || customer?.applicationId === undefined) ? 'Register customer' : 'Complete application', color: ColorTokens.Primary_100, textAlign: TextAlignTokens.center })))));
    };
    const handleScroll = ({ nativeEvent }) => {
        if (isCloseToBottom(nativeEvent) && !hasReachedBottom) {
            setHasReachedBottom(true);
            if (currentPageNumber <= PendingCustomerData?.totalPages) {
                setCurrentpageNumber(currentPageNumber + 1);
                fetchMoreData();
            }
        }
        else if (!isCloseToBottom(nativeEvent) && hasReachedBottom) {
            setHasReachedBottom(false); // Reset flag when the user scrolls up
        }
    };
    const fetchMoreData = async () => {
        if (currentActiveTabIndex === 1) {
            await triggerAction({
                ...pendingCustomerAction,
                payload: {
                    currentPage: currentPageNumber,
                    searchContext: searchText,
                    ...pendingCustomerAction.payload
                }
            });
        }
        else if (currentActiveTabIndex === 2) {
            await triggerAction({
                ...pendingRegisteredCustomerAction,
                payload: {
                    currentPage: currentPageNumber,
                    searchContext: searchText,
                    ...pendingRegisteredCustomerAction.payload
                }
            });
        }
        else if (currentActiveTabIndex === 3) {
            await triggerAction({
                ...registeredCustomerAction,
                payload: {
                    currentPage: currentPageNumber,
                    searchContext: searchText,
                    ...registeredCustomerAction.payload
                }
            });
        }
    };
    const renderItem = ({ item, index }) => {
        return renderCustomerCard(item);
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { marginHorizontal: 16, marginTop: 24 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H2S, label: 'Pending applications', color: ColorTokens.Grey_Night }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: 'Create & track loan applications in progress', color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { marginTop: 16, flexDirection: 'row' } },
                showLink &&
                    React.createElement(View, { style: { width: '48%' } },
                        React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: `Share unique link`, onPress: async () => {
                                await triggerAction({
                                    ...shareLinkRef,
                                    payload: {
                                        ...shareLinkRef.payload,
                                    }
                                });
                            }, isDisabled: false })),
                showRC &&
                    React.createElement(View, { style: { width: '48%', marginLeft: 12 } },
                        React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: `Register customer`, onPress: async () => {
                                await triggerAction({
                                    ...trackPendingCustomerJourney,
                                    payload: {
                                        customerType: 'PENDING_REGISTRATION',
                                        ...trackPendingCustomerJourney.payload,
                                    }
                                });
                            }, isDisabled: false }))),
            React.createElement(View, { style: { marginVertical: 12 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, style: { flexDirection: 'row', width: '100%' } },
                React.createElement(HorizontalFilterComp, { title: 'All', noOfItems: dataCount?.allCount || '0', selected: currentActiveTabIndex === 1 ? true : false, activeIndex: 1, onPress: onTabPress }),
                React.createElement(View, { style: { marginHorizontal: 12 } },
                    React.createElement(HorizontalFilterComp, { title: 'Registration pending', noOfItems: dataCount?.registrationPendingCount || '0', selected: currentActiveTabIndex === 2 ? true : false, activeIndex: 2, onPress: onTabPress })),
                React.createElement(HorizontalFilterComp, { title: 'Registration completed', noOfItems: dataCount?.registrationCompletedCount || '0', selected: currentActiveTabIndex === 3 ? true : false, activeIndex: 3, onPress: onTabPress })),
            React.createElement(View, { style: { marginRight: 10, marginTop: 24, width: '100%' } },
                React.createElement(TextInput, { state: InputStateToken.DEFAULT, alphaNumericSpace: true, type: InputTypeToken.SEARCH, keyboardType: KeyboardTypeToken.default, title: 'Search applications', needSearchIcon: true, onChangeText: (text) => {
                        setSearchText(text);
                        handleSearch(text);
                    }, value: searchText, placeholder: `Search by name or phone number`, clearTextAction: clearTextSearchAction })),
            pendingDataFetched === false && React.createElement(ShimmerPlaceholder, { style: {
                    width: '50%',
                    height: 48,
                    marginTop: 16,
                    borderRadius: 8,
                } }),
            (pendingDataFetched === true && data?.length > 0) && React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Showing ${data?.length} ${data?.length > 1 ? 'customers' : 'customer'} `, color: ColorTokens.Grey_Night })),
            React.createElement(ScrollView, { style: {} },
                (pendingDataFetched === true && isDataFetched === true) && (data?.length === 0 || !data) &&
                    React.createElement(EmptyScreen, { triggerAction: triggerAction, shareLinkAction: shareLinkRef, trackPendingCustomerJourney: trackPendingCustomerJourney }),
                (pendingDataFetched === false) && React.createElement(ShimmerTable, null)),
            React.createElement(ScrollView, { scrollEventThrottle: 400, onScroll: handleScroll, style: {
                    height: height - 300,
                    paddingBottom: 80,
                    marginTop: 16,
                }, ref: scrollViewRef },
                React.createElement(FlatList, { removeClippedSubviews: true, windowSize: data?.length || 50, data: data, keyExtractor: (item, index) => "" + index, renderItem: renderItem, nestedScrollEnabled: true, ListFooterComponent: (currentPageNumber <= PendingCustomerData?.totalPages && data?.length > 0) ? React.createElement(ActivityIndicator, { color: '#1434CB', size: 22 }) : React.createElement(React.Fragment, null) }))));
    };
    return (React.createElement(BoilerPlate, { height: height - 40, backgroundColor: ColorTokens.White, bottomChildren: React.createElement(React.Fragment, null) }, renderContent()));
};
const styles = StyleSheet.create({});
export default PendingApplicationMobileScreen;
